<lex-case-analytics-item>
    @if (custodianSummary === null) {
        <div card-header-content-primary *ngIf="!shouldShowLoader" [@appear]>
            <div>Top 10 Custodians</div>
            <div>Custodians with <b>the most data.</b></div>
        </div>
    }
    @else {
        <div card-header-content-primary *ngIf="!shouldShowLoader" [@appear]>
            <div>{{custodianSummary.name}}</div>
            <div>{{custodianSummary.assignedDocuments | number}}</div>
            <div>Documents assigned to this custodian</div>
        </div>
    }
    <div card-body-content-chart  *ngIf="barChartData?.length > 0" [ngClass]="{'loading': shouldShowLoader === true}">
            <canvas baseChart [data]="{
                labels: barChartLabels,
                datasets: barChartData
                }"
                [options]="barChartOptions"
                [plugins]="ngChartPlugins"
                [type]="barChartType"
                [legend]="barChartLegend"
                (chartHover)="displayCustodianSummary($event)"
                aria-label="Bar chart showing the top custodians." role="img">
        </canvas>
    </div>
  <div card-body-content-chart *ngIf="shouldShowLoader" style="display: flex; align-items: center; justify-content: center;">
    <i card-body-loading-icon class="fa-light fa-chart-waterfall fa-fade" style="font-size: 19.2vh;"></i>
  </div>
</lex-case-analytics-item>
